import { Component, Prop, Vue } from "vue-property-decorator";
import icons from "@/assets/data/icons.json";

@Component
export default class BaseIconComponent extends Vue {
  @Prop() name!: string;
  @Prop() width!: string;
  @Prop() height!: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  iconsPaths!: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get icon(): any {
    return this.iconsPaths[this.name];
  }
  get paths(): string[] {
    return this.icon?.path;
  }

  get iconWidth(): string {
    return this.width ? this.width : this.icon?.width;
  }

  get iconHeight(): string {
    return this.height ? this.height : this.icon?.height;
  }

  created(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.iconsPaths = Object.assign({}, icons) as any;
  }
}
